const apiMixin = (Base = class Empty {}) => class extends Base {

	injectApi(api) {
		this.api = api;
	}

};

export default apiMixin;
